module.exports = __webpack_public_path__ + "img/DFW_NatureStaff.7769afa1.png";